<template>
  <div class="live-trainings-list" :class="{ dark }">
    <div class="container">
      <div class="row">
        <div class="col col-3">
          <FiltersAccordion
            v-if="$store.state.layout === 'desktop'"
            :filters="filters"
            :dark="dark"
            :reset="filtersReset"
            :de-selected="deSelected"
            @change="filtrate"
          />
        </div>
        <div class="col col-9">
          <div class="search">
            <div class="search-holder">
              <SearchBar
                :dark="dark"
                :placeholder="$store.state.layout === 'mobile' ? 'Search' : 'Search trainings'"
                :value="clearSearch"
                @search="search"
              />
              <Filters
                v-if="$store.state.layout === 'mobile'"
                :filters="filters"
                :dark="dark"
                applied-counter
                :reset="filtersReset"
                :de-selected="deSelected"
                @change="filtrate"
              />
            </div>
            <SearchResults
              key="searchLabels"
              :dark="dark"
              :filters="filters"
              :labels="searchLabels"
              @closeLabel="close"
              @clearAll="reset"
            />
          </div>
          <div class="row results">
            <Card
              v-for="(training, id) in trainings.info" :key="id"
              :training="training" :to="`${training.slug}/`" :dark="dark"
              heading="h3"
            />
          </div>
          <Pagination
            v-if="trainings.count > 9"
            :page="page"
            :total="trainings.count"
            :per-page="9"
            align="center"
            :links="false"
            @pagechanged="setPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FiltersAccordion from '../FiltersAccordion';
import SearchResults from '../SearchResults';
import Card from './Card';
import SearchBar from '../SearchBar';
import Filters from '../../components/Filters';
import Pagination from '../../components/Pagination';

export default {
  components: {
    FiltersAccordion,
    SearchResults,
    Filters,
    SearchBar,
    Card,
    Pagination,
  },
  props: {
    dark: Boolean,
  },
  data() {
    return {
      trainings: { info: [], count: 0 },
      page: 1,
      keyword: '',
      searchLabels: {},
      deSelectedOption: {},
      resetFilters: false,
    };
  },
  async fetch() {
    await this.fetchTrainings();
    this.searchLabels = {
      results: this.trainings.count,
      searchData: this.keyword,
      filtersData: {},
    };
  },
  computed: {
    filters() {
      const topics = {
        'machine learning': { text: 'Machine Learning' },
        'deep learning': { text: 'Deep Learning' },
        'data engineering': { text: 'Data Engineering' },
        'bi analysis': { text: 'Bi Analysis' },
        'data architecture': { text: 'Data Architecture' },
        'data science': { text: 'Data Science' },
        'cloud service': { text: 'Cloud Service' },
        'artificial intelligence': { text: 'Artificial Intelligence' },
      };

      const difficulty = {
        beginner: { text: 'Beginner' },
        intermediate: { text: 'Intermediate' },
        advanced: { text: 'Advanced' },
      };

      const duration = {
        1: { text: '1h-3h' },
        2: { text: '3h-5h' },
        3: { text: '5h-8h' },
        4: { text: '8h-12h' },
        5: { text: '12h-15h' },
        6: { text: '15h+' },
      };

      const targetAudience = {
        'business leaders': { text: 'Business Leaders' },
        'project managers': { text: 'Project Managers' },
        'data scientists': { text: 'Data Scientists' },
        'data engineers': { text: 'Data Engineers' },
        'ml engineers': { text: 'ML Engineers' },
        'ai practitioners': { text: 'AI Practitioners' },
        'business analysts': { text: 'Business Analysts' },
        'marketing experts': { text: 'Marketing Experts' },
        'computer engineers': { text: 'Computer Engineers' },
      };

      const technologies = {
        python: { text: 'Python' },
        sql: { text: 'SQL' },
        r: { text: 'R' },
        excel: { text: 'Excel' },
        tableau: { text: 'Tableau' },
        powerbi: { text: 'Powerbi' },
        git: { text: 'Git' },
        theory: { text: 'Theory' },
        jupyter: { text: 'Jupyter' },
      };

      return {
        topics: {
          name: 'Topics',
          // labelsAsValues: true,
          type: 'multiple',
          values: topics,
          open: true,
        },
        difficulty: {
          name: 'Level of difficulty',
          // labelsAsValues: true,
          type: 'multiple',
          values: difficulty,
          open: true,
        },
        duration: {
          name: 'Duration',
          type: 'multiple',
          values: duration,
          open: true,
        },
        targetAudience: {
          name: 'Target Audience',
          // labelsAsValues: true,
          type: 'multiple',
          values: targetAudience,
          open: true,
        },
        technologies: {
          name: 'Technology',
          // labelsAsValues: true,
          type: 'multiple',
          values: technologies,
          open: true,
        },
      };
    },
    deSelected() {
      return this.deSelectedOption;
    },
    filtersReset() {
      return this.resetFilters;
    },
    clearSearch() {
      return this.keyword;
    },
  },
  methods: {
    close(label) {
      if (label.type === 'search') {
        this.keyword = '';
      } else {
        this.deSelectedOption = label;
      }
    },
    reset() {
      this.resetFilters = true;
    },
    async fetchTrainings() {
      this.trainings = await this.$axios.$get(`/business/live-trainings/?page=${this.page}${this.keyword ? `&search=${this.keyword}` : ''}${this.$config.project ? `&origin=${this.$config.project}` : ''}${this.filter ? `&${this.filter}` : ''}`);

      this.searchLabels.results = this.trainings.count;
      this.searchLabels.searchData = this.keyword;
    },
    async filtrate(f) {
      this.page = 1;
      this.filter = f.params;
      await this.fetchTrainings();
      this.searchLabels.filtersData = f.filter;
      this.resetFilters = false;
    },
    search(k) {
      this.keyword = k;
      this.fetchTrainings();
    },
    setPage(page) {
      this.page = page;
      this.fetchTrainings();
      this.$nextTick(() => {
        document.querySelector('.live-trainings-list').parentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
  },
};
</script>

<style lang="scss">
.live-trainings-list {
  .row {
    align-items: flex-start;
  }

  .col.row {
    margin-left: 0;
    margin-right: 0;
  }

  .search-holder {
    .search-bar input {
      height: 48px;
    }
  }

  .pagination {
    width: 100%;
  }
}

@include bp($bp-mobile) {
  .live-trainings-list {
    .search {
      margin-bottom: var(--spacing-16);
      padding: 0;

      .search-holder {
        display: flex;
        justify-content: space-between;

        .__filters {
          &.dark {
            .filter-button {
              border: 1px solid var(--main-dark-light-4);

              svg path[fill] {
                fill: var(--main-dark-light-4);
              }
            }
          }
        }
      }
    }

    .results {
      padding: 0 var(--spacing-12);
    }

    .training-card {
      margin-bottom: 24px;
      padding: 0;
    }
  }
}

@include bp($bp-phone) {
  .live-trainings-list {
    .search {
      .search-holder {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;

        .search-bar-wrapper {
          max-width: 83.33333%;
          width: 83.33333%;
          flex: 0 0 83.33333%;

          .search-bar {
            input {
              height: 48px;
            }

            .search-icon {
              top: 14px;
            }

            .close-btn {
              top: 17px;
            }
          }
        }

        .__filters {
          .filter-button {
            height: 48px;
            width: 48px;
          }
        }
      }

      .results-wrapper {
        margin-top: var(--spacing-20);
        margin-bottom: var(--spacing-32);
      }
    }
  }
}
</style>
